module.exports = __webpack_public_path__ + "img/image15.3039ce60.jpg";